// extracted by mini-css-extract-plugin
module.exports = {"popover":"i_AG","container":"i_AH","sections":"i_AI","sidebar":"i_AJ","headline":"i_AK"};